<script lang="ts">
  import EncartPromotionParcoursBasique from '../../parcours-securisation/EncartPromotionParcoursBasique.svelte';
  import TagProgrammeGratuit from '../../parcours-securisation/TagProgrammeGratuit.svelte';
  import EncartInvitationARenforcerCybersecurite from '../../test-maturite/EncartInvitationARenforcerCybersecurite.svelte';
  import PartageTest from '../../test-maturite/PartageTest.svelte';
  import EnteteAutonome from '../../ui/EnteteAutonome.svelte';
  import Notice from '../../ui/Notice.svelte';
  import CarteRisqueExposition from './CarteRisqueExposition.svelte';
  import type { MenaceEvaluee } from './expositionCyberattaques';

  const { menaces, mode, urlBase = '' }: { menaces: MenaceEvaluee[]; mode?: 'autonome'; urlBase?: string } = $props();
</script>

{#if mode === 'autonome'}
  <div class="entete">
    <dsfr-container>
      <EnteteAutonome {urlBase} />
    </dsfr-container>
    {@render conteneur()}
  </div>
{:else}
  {@render conteneur()}
{/if}

{#snippet conteneur()}
  <dsfr-container class="conteneur">
    <div class="résultats">
      <Notice
        type="attention"
        estRejetable={false}
        aUneIcone
        titre="Votre organisation présente des facteurs d’exposition aux cyberattaques"
      />

      <h2>Détail des risques</h2>
      <div class="grille-cartes">
        {#each menaces as menace (menace.id)}
          <CarteRisqueExposition {menace} {urlBase} />
        {/each}
      </div>
    </div>
  </dsfr-container>
{/snippet}

<EncartInvitationARenforcerCybersecurite />
<section class="section-parcours-basique">
  <EncartPromotionParcoursBasique
    titre="12 mesures simples pour protéger votre organisation contre les cyberattaques"
    description="Accédez à 12 mesures simples pour protéger dès maintenant votre organisation contre les cyberattaques et prendre votre Cyberdépart ! 🚀"
    {mode}
    {urlBase}
  >
    {#snippet tags()}
      <TagProgrammeGratuit />
    {/snippet}
  </EncartPromotionParcoursBasique>
</section>

{#if mode !== 'autonome'}
  <PartageTest
    cheminPartagé="/exposition"
    sujetMail="Mon organisation est-elle exposée aux cyberattaques ?"
    typeDeRetour="exposition"
  />
{/if}

<dsfr-container class="note-source">
  <p class="texte-mention-xs">
    Sources : Panorama de la cybermenace 2025 — ANSSI (CERTFR-2026-CTI-002) ; Rapport d'activité 2025 —
    Cybermalveillance.gouv.fr (GIP ACYMA), fondé sur les signalements et demandes d'assistance de professionnels reçus
    en 2025.<br />
    <br />
    Cette évaluation mesure des facteurs d'exposition et de sinistralité observée, non une prédiction de la probabilité d'incident
    — laquelle dépend aussi de votre niveau de maturité cyber (sécurisation, sauvegardes, sensibilisation des équipes, etc.),
    non mesuré ici.
  </p>
</dsfr-container>

<style lang="scss">
  @use '../../../../assets/styles/responsive' as *;
  @use '../../../../assets/styles/grille' as *;

  dsfr-container {
    &.conteneur {
      display: block;
      margin-bottom: 2rem;
    }
  }

  .résultats {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    h2 {
      margin-bottom: 0;
    }

    .grille-cartes {
      display: grid;
      gap: 1.5rem;
      grid-template-columns: minmax(0, 1fr);

      @include a-partir-de(md) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      @include a-partir-de(lg) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }
  }

  .section-parcours-basique {
    background-color: var(--background-alt-yellow-moutarde);
    padding-block: 6rem;
    margin-top: 3.5rem;
  }

  .note-source {
    background-color: var(--background-alt-grey);
    padding: 1.5rem 0;

    p {
      margin: 0;
    }
  }

  .entete {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
</style>
